import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { runInAction } from 'mobx';

import { routesMonitoringRootStore } from '../stores/routes-monitoring-root-store';

const listen = (updateIntervalMs: number) => {
	const { dashboardSdk } = getRootEnv();
	const intervalData = { updateIntervalMs, timeoutId: undefined };

	const unsubscribe = dashboardSdk.sdk.users.onUpdate((driver: Bringg.Driver) => {
		scheduleEvent(intervalData, driver);
	});

	return () => {
		intervalData.timeoutId && clearTimeout(intervalData.timeoutId);
		unsubscribe();
	};
};

function scheduleEvent(intervalData: { timeoutId: number; updateIntervalMs: number }, driver: Bringg.Driver) {
	if (!driver) {
		return;
	}

	const { routeMonitoringMapViewStore } = routesMonitoringRootStore.getStore();

	const itemId = driver.id;

	const shouldDisplayDriverOnMap = routeMonitoringMapViewStore._visibleDrivers.has(itemId);

	if (!shouldDisplayDriverOnMap) {
		return;
	}

	if (!intervalData.timeoutId) {
		intervalData.timeoutId = window.setTimeout(() => {
			runInAction(() => {
				routeMonitoringMapViewStore.setDriversMarkers();
			});
			delete intervalData.timeoutId;
		}, intervalData.updateIntervalMs);
	}
}

export const driversLocationListener = { listen };
